var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'model-content': _vm.pid },attrs:{"id":"model"}},[_c('div',{staticClass:"page-content",attrs:{"id":"page-content"}})])}
var staticRenderFns = []

export { render, staticRenderFns }